import type { CompletionResult } from '@codemirror/autocomplete';
import { CompletionContext } from '@codemirror/autocomplete';

import type { IntlProps } from '../../utils/render-node.js';
import { autocompletionExtension } from '../autocompletion.extension.js';
import type { ListAutocompletionConfig } from './list-autocompletion-types.js';
import { listAutocompletion } from './list-autocompletion.js';

export const listAutocompletionExtension = (
  listAutoCompletionConfig: ListAutocompletionConfig,
  intlProps: IntlProps,
): ((ctx: CompletionContext) => Promise<CompletionResult | null>) => {
  return autocompletionExtension(
    listAutocompletion(listAutoCompletionConfig),
    intlProps,
  );
};
